export default __webpack_public_path__ + "static/media/63.df02d44d.png";